import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'i18n-react';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import ReactPlaid from "react-plaid";
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { bindActionCreators } from 'redux';
import validator from 'validator';
import { getCardTypeIdFromIFrame } from '../constants/CardTypeConstants';
import { PaymentValidationResult } from '../constants/PaymentValidationResultConstants';
import { PaymentVendorProcessType } from '../constants/PaymentVendorProcessTypeConstants';
import * as CommonStore from '../store/Common';
import * as PaymentStore from '../store/Payment';
import * as UserStore from '../store/User';
import IFrameManager from './payment/IFrameManager';
import ConfirmModal from './shared/ConfirmModal';
import LoadingButton from './shared/LoadingButton';
import LoadingOverlay from './shared/LoadingOverlay';
import MessageError from './shared/MessageError';
import PaymentSummary from './shared/PaymentSummary';


const time = require(`../images/${process.env.REACT_APP_CLIENT}/time.png`);
const bag = require(`../images/${process.env.REACT_APP_CLIENT}/bag.png`);

export const QuickPaySteps = Object.freeze({
    Step1CustomerInfo: 1,
    Step2PaymentSummary: 2,
    Step3PaymentSending: 3,
    Step4PaymentConfirmation: 4
});

const initialState = {
    step: QuickPaySteps.Step1CustomerInfo,
    sentToBackend: false,
    accountNumber: '',
    lastName: '',
    zipCode: '',
    tenderTypeID: "1",
    amount: '',
    nameOnAccount: '',
    cardZipCode: '',
    bankAccountNumber: '',
    routingNumber: '',
    bankAccountType: '0',
    reactPlaidOpen: false,
    account_id: '',
    fields: [
        { name: 'accountNumber', isRequired: true, step: QuickPaySteps.Step1CustomerInfo },
        { name: 'lastName', isRequired: true, step: QuickPaySteps.Step1CustomerInfo },
        { name: 'zipCode', isRequired: true, step: QuickPaySteps.Step1CustomerInfo }, //2
        { name: 'amount', isRequired: false, isNumeric: true, isNumericError: false, step: QuickPaySteps.Step2PaymentSummary, minPaymentAmount: 0, conditionField: '', isMinimumAmountError: false },
        { name: 'cardNumberValue', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '1', paymentStripeRequired: 'always', isDomValue: true },
        { name: 'expiration', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '1', paymentStripeRequired: 'always', isDomValue: true },
        { name: 'ccv', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '1', paymentStripeRequired: 'always', isDomValue: true },
        { name: 'nameOnAccount', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '1', paymentStripeRequired: 'always' },
        { name: 'cardZipCode', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '1', paymentStripeRequired: 'always' }, //8
        { name: 'bankAccountNumber', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '2', paymentStripeRequired: false },
        { name: 'routingNumber', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '2', paymentStripeRequired: false }, //10
        { name: 'account_id', isRequired: true, step: QuickPaySteps.Step3PaymentSending, conditionField: 'tenderTypeID', conditionValue: '2', paymentStripeRequired: true }
    ],
    //CV ZD14560 2020/03/26 adding this properties to handle client stripe token generation
    tokenizeCreditDetails: false,
    infoCreditCardFeeModalVisible: false,
    cardZipCodeStripe: '',
    paymentStripePK: '',
    stripe: {},
    elements: {},
    cardNumberElement: {},
    cardExpiryElement: {},
    cardCvcElement: {}
};

class QuickPayModal extends Component {

    constructor(props) {
        super(props);

        this.cardNumberValueRef = React.createRef();
        this.expirationRef = React.createRef();
        this.ccvRef = React.createRef();

        this.state = initialState;

        var paymentStripePK = this.props.getPaymentStripePK();

        this.state.paymentStripePK = this.props.getPaymentStripePK();

        //CV ZD14560 2020/03/26 adding this script to load the stripe main scripts
        if (paymentStripePK) {
            const script = document.createElement("script");
            script.src = "https://js.stripe.com/v3/";
            script.async = true;
            document.body.appendChild(script);
        }

    }

    componentWillReceiveProps = async (nextProps) => {
        if (nextProps.quickPayAccountFound && this.state.step === QuickPaySteps.Step1CustomerInfo) {

            //set min payment amount from properties only for prepay
            let state = this.state;
            var amountField = state.fields[3];
            var isPrepay = nextProps.quickPayAccount.accountBillingTypeID === 1;
            amountField.minPaymentAmount = isPrepay ? this.props.systemProperties.myAcctAutopayMinimumPayment : 0;
            this.setState({ fields: state.fields, step: QuickPaySteps.Step2PaymentSummary });

            let userName = nextProps.quickPayAccount.accountNumber;
            if (nextProps.quickPayAccount.persons) {
                let person = nextProps.quickPayAccount.persons[0];
                userName = person.emailAddress || person.fullName || userName;
            }

            // Get hosted payment page configuration for QuickPay with dynamic parameters
            // companyId from quickPayAccount, tenderTypeId based on current selection, paymentVendorProcessTypeID = PaymentVendorProcessType.RegularPayment for one-time payment
            const request = {
                actions: ['iFrameSettings'],
                accountID: nextProps.quickPayAccount.accountID,
                accountNumber: nextProps.quickPayAccount.accountNumber,
                userName: userName,
                companyID: nextProps.quickPayAccount.companyID,
                tenderTypeID: parseInt(this.state.tenderTypeID), // Use current tender type selection
                paymentVendorProcessTypeID: PaymentVendorProcessType.RegularPayment, // One-time payment for QuickPay
                isPayment: true,
                saveProfile: true
            };

            await this.props.runHostedPaymentPageActions(request);

            //CV ZD14560 2020/03/26 adding this validation if stripe PK is enable then load the stripe script, and build the respective objects
            if (this.state.paymentStripePK && this.state.tenderTypeID === '1') {
                const script = document.createElement("script");
                script.src = "https://js.stripe.com/v3/";
                script.async = true;
                script.onload = () => {
                    //Creating the main stripe objects
                    this.setState({ stripe: window.Stripe(this.state.paymentStripePK) });
                    this.setState({ elements: this.state.stripe.elements() });
                    //Create cardnumber element (this is the main element)
                    this.setState({ cardNumberElement: this.state.elements.create('cardNumber', { placeholder: ' ' }) });
                    this.state.cardNumberElement.mount('#txtCreditCardStripe');
                    //Create cardexpiry element
                    this.setState({ cardExpiryElement: this.state.elements.create('cardExpiry', { placeholder: ' ' }) });
                    this.state.cardExpiryElement.mount('#txtExpireStripe');
                    //Create cardcvc element
                    this.setState({ cardCvcElement: this.state.elements.create('cardCvc', { placeholder: ' ' }) });
                    this.state.cardCvcElement.mount('#txtCcvStripe');
                };
                document.body.appendChild(script);
            } else {
                //account was found, see if i4go payment is enabled
                this.props.getI4GoAuthorizeClient();
            }

        }

        if (this.state.step === QuickPaySteps.Step2PaymentSummary) {
            const { useHostedPaymentPage } = this.props;
            const { paymentValidationResult } = nextProps;

            if (useHostedPaymentPage && paymentValidationResult === PaymentValidationResult.Approved) {
                this.setState({ step: QuickPaySteps.Step3PaymentSending });
            }
        }

        if (this.state.step === QuickPaySteps.Step3PaymentSending && nextProps.quickPaymentSuccess) {
            this.setState({ step: QuickPaySteps.Step4PaymentConfirmation });
        }
    }

    componentDidUpdate(prevProps) {
        // Check if the modal was just opened
        // It's visible now, but it wasn't visible before
        if (this.props.quickPayModalVisible && !prevProps.quickPayModalVisible) {
            this.setState({ ...initialState });
        }
    }

    onChange = (e) => {

        let fields = this.state.fields.filter(x => x.name === e.target.name);

        if (fields && fields.length === 1) {

            let field = fields[0];

            if (field.isRequired && field.isRequiredError && e.target.value) {
                field.isRequiredError = false;
            }

            if (field.isNumeric && e.target.value && validator.isDecimal(e.target.value)) {
                field.isNumericError = false;
            }
            //clean amount field if min payment amount is met
            if (field.isNumeric && e.target.value && field.minPaymentAmount &&
                parseFloat(e.target.value) >= field.minPaymentAmount) {
                field.isMinimumAmountError = false;
            }

            if (field.name == 'amount') {
                const customAmount = parseFloat(e.target.value);
                if (Number.isNaN(customAmount)) {
                    e.target.style.borderColor = 'white';
                }
                else {
                    const borderColor = customAmount && customAmount > 0 ? 'green' : 'red';
                    e.target.style.border = `4px solid ${borderColor}`;
                }
            }
        }

        this.setState({ [e.target.name]: e.target.value });
    }

    isFormValid = () => {

        var formData = { ...this.state };
        var valid = true;
        var paymentStripeRequired = this.props.paymentStripe ? true : false;

        this.state.fields.forEach((field) => {

            if (field.step === formData.step) {

                if (field.isDomValue) {
                    // Check if ref exists and is mounted before accessing
                    const ref = this[field.name + 'Ref'];
                    if (ref && ref.current) {
                        field.value = ref.current.value;
                    } else {
                        field.value = '';
                    }
                } else {
                    field.value = formData[field.name];
                }

                field.isRequiredError = false;

                if (!field.conditionField) {

                    if (field.isRequired && !field.value) {
                        field.isRequiredError = true;
                        valid = false;
                    } else if (field.isNumeric && field.value && !validator.isDecimal(field.value)) {
                        //validate numeric value for amount field
                        field.isNumericError = true;
                        valid = false;
                    } else if (field.minPaymentAmount && parseFloat(field.value) < field.minPaymentAmount) {
                        //validate min payment amount for amount field - ONLY PREPAY
                        field.isMinimumAmountError = true;
                        valid = false;
                    }

                } else if (field.conditionField && field.conditionValue === formData[field.conditionField] && (field.paymentStripeRequired === paymentStripeRequired || field.paymentStripeRequired === 'always')) {

                    if (field.isRequired && !field.value) {
                        field.isRequiredError = true;
                        valid = false;
                    }

                    if (field.isNumeric && field.value && !validator.isDecimal(field.value)) {
                        field.isNumericError = true;
                        valid = false;
                    }
                }

                if (field.isDomValue) {
                    delete field.value;
                }
            }

        });

        this.setState(formData);

        if (valid) {
            this.props.setQuickPayError('');
        } else {
            this.props.setQuickPayError(T.translate("common.thereAreMissingFields"));
        }

        return valid;
    }

    toggle = () => {
        //clear any payment-specific state
        this.props.clearPaymentState();
        //clear any user-specific state
        this.props.clearUserState();
        //close the modal and clear Redux payment state
        this.props.setQuickPayModalVisible(!this.props.quickPayModalVisible);
    }

    next = async () => {
        var { step } = this.state;
        var request = { ...this.state };
        if (step == QuickPaySteps.Step1CustomerInfo) {
            if (this.isFormValid()) {
                this.props.getAccount(request);
            }
        } else if (step === QuickPaySteps.Step2PaymentSummary) {
            const { useHostedPaymentPage, paymentValidationResult } = { ...this.props };

            if (useHostedPaymentPage) {
                if (paymentValidationResult === PaymentValidationResult.Unset) {
                    const account = { ...this.props.quickPayAccount };
                    const tenderTypeID = parseInt(this.state.tenderTypeID);
                    const paymentVendorProcessTypeID = PaymentVendorProcessType.RegularPayment; // One-time payment for QuickPay

                    let userName = account.accountNumber;
                    if (account.persons) {
                        let person = account.persons[0];
                        userName = person.fullName;
                    }

                    const request = {
                        accountID: account.accountID,
                        accountNumber: account.accountNumber,
                        userName: userName,
                        companyID: account.companyID,
                        amount: this.getAmount(),
                        tenderTypeID,
                        paymentVendorProcessTypeID,
                        keepLoadingSpinner: true,
                        isPayment: true,
                        saveProfile: true,
                        isQuickPay: true
                    };
                    await this.props.runHostedPaymentPageActions(request);
                }
            } else {
                this.setState({ step: step + 1 });
            }
        }
    }

    back = () => {
        const { step } = this.state;
        const { useHostedPaymentPage } = { ...this.props };

        if (step === QuickPaySteps.Step3PaymentSending && useHostedPaymentPage) {
            this.props.resetPaymentValidation();
        }

        // SGCIS-11192: clear the latch so the next attempt can be submitted and onIFrameLoaded lowers
        // the spinner again on Step 3.
        this.setState({ sentToBackend: false, step: step - 1 });
    }

    validateAmountTreshold = () => {

        var state = this.state;
        var valid = true;
        var paymentStripeRequired = this.props.paymentStripe ? true : false;

        this.state.fields.forEach((field) => {

            if (field.step === state.step && field.name === "amount") {
                field.value = this.state[field.name];
                field.isRequiredError = false;

                if (!field.conditionField) {
                    if (field.isRequired && !field.value) {
                        field.isRequiredError = true;
                        valid = false;
                    } else if (field.isNumeric && field.value && !validator.isDecimal(field.value)) {
                        //validate numeric value for amount field
                        field.isNumericError = true;
                        valid = false;
                    } else if (field.minPaymentAmount && parseFloat(field.value) < field.minPaymentAmount) {
                        //validate min payment amount for amount field - ONLY PREPAY
                        field.isMinimumAmountError = true;
                        valid = false;
                    }
                }

            }

        });

        this.setState(state);

        if (valid) {
            this.props.setQuickPayError('');
        } else {
            this.props.setQuickPayError(T.translate("common.thereAreMissingFields"));
        }

        return valid;
    }

    pay = () => {
        // Check if using iframe hosted payment page
        if (this.props.useHostedPaymentPage && this.state.iFramePaymentToken) {
            const paymentMethod = this.state.tenderTypeID === '1' ? 'iFrameCreditCard' : 'iFrameECheck';
            const paymentData = {
                ...this.state,
                paymentToken: this.state.iFramePaymentToken,
                paymentMethod: paymentMethod,
                tenderTypeID: parseInt(this.state.tenderTypeID)
            };
            this.setState({ sentToBackend: true });
            this.props.quickPay(paymentData);
            return;
        }

        // If using hosted payment page but no token yet, show error
        if (this.props.useHostedPaymentPage && !this.state.iFramePaymentToken) {
            this.props.setQuickPayError(T.translate('quickPay.pleaseCompletePaymentForm') || 'Please complete the payment form first');
            return;
        }

        //CV ZD14560 2020/03/26 adding this validation if stripe PK is enable,  then the token will be and the payment account will be submited
        if (this.state.paymentStripePK && this.validateAmountTreshold() && this.state.tenderTypeID === '1') {
            var options = {
                cardZipCode: this.state.cardZipCode
            };
            // SGCIS-11192: latch before tokenization starts, not after it resolves, or a second click
            // can start a second tokenization and both callbacks post a payment.
            this.setState({ sentToBackend: true });

            //Create stripe token for this card, after that it is submited to the backend among with the other card information not sensitive
            this.state.stripe.createToken(this.state.cardNumberElement, options).then((result) => {
                if (result.error) {
                    // Inform the customer that there was an error generating the token.
                    this.props.setPaymentError(result.error.message);

                    // Nothing was charged, so release the latch and let the customer correct the card.
                    this.setState({ sentToBackend: false });
                } else {
                    this.setState({ paymentToken: result.token.id });
                    //this.setState({ cardNumberValue: '************' + result.token.card.last4 });
                    //this.setState({ expireMonth: result.token.card.exp_month });
                    //this.setState({ expireYear: result.token.card.exp_year });
                    this.setState({ cardZipCode: this.state.cardZipCodeStripe });
                    //this.setState({ ccv: 123 });

                    let normalizedCardData = {
                        cardNumberValue: '************' + result.token.card.last4,
                        expireMonth: result.token.card.exp_month,
                        expireYear: result.token.card.exp_year,
                        ccv: 123
                    };
                    this.props.postAccountQuickPay({ ...this.state, ...normalizedCardData });
                }
            });
        }
        else {
            if (this.isFormValid()) {
                let rawData = { ...this.state };
                if (this.state.tenderTypeID === '1') {
                    let expiration = this.expirationRef.current.value;
                    let cardNumberValue = this.cardNumberValueRef.current.value;
                    let ccv = this.ccvRef.current.value;

                    rawData.cardNumberValue = cardNumberValue;
                    rawData.expiration = expiration;
                    rawData.ccv = ccv;
                }
                else {
                    rawData.accountNumber = rawData.bankAccountNumber;
                }

                // SGCIS-11192: latch the direct-post path too. It is the branch this button actually
                // uses, and it was the only submit route with no protection at all.
                this.setState({ sentToBackend: true });
                this.props.postAccountQuickPay(rawData);
            }
        }
    }

    openCreditCardFeeModal = () => {
        this.setState({ infoCreditCardFeeModalVisible: true });
    }

    closeCreditCardFeeModal = () => {
        this.setState({ infoCreditCardFeeModalVisible: false });
    }


    reactPlaidSuccess = (token, metaData) => {
        this.setState({ account_id: metaData.account_id, public_token: metaData.public_token, reactPlaidOpen: false });
    }

    onTokenizeCreditDetailsClick = (e) => {
        this.setState({ tokenizeCreditDetails: !this.state.tokenizeCreditDetails });
    }

    showCreditCardFeeWarning = () => {
        return this.props.systemProperties.creditCardCharge && this.props.systemProperties.creditCardCharge != "" && this.props.systemProperties.creditCardCharge > 0;
    }

    showeCheckFeeWarning = () => {
        return this.props.systemProperties.eCheckCharge && this.props.systemProperties.eCheckCharge != "" && this.props.systemProperties.eCheckCharge > 0;
    }

    onIFrameLoaded = () => {
        if (!this.state.sentToBackend) {
            this.props.hideLoadingSpinner();
        }
    }

    // iFrame related methods for QuickPay
    onIFrameResponse = (response) => {
        this.props.setIFrameResponse(response);

        if (!response.error && response.token) {
            this.setState({ iFramePaymentToken: response.token });
            this.props.setQuickPayError('');
        } else {
            this.props.setQuickPayError(response.error || 'Payment form error occurred');
        }
    }

    onIFramePaymentSuccess = (response) => {
        let state = { ...this.state };

        // Prepare payment data with iframe token
        const paymentMethod = state.tenderTypeID === '1' ? 'iFrameCreditCard' : 'iFrameECheck';
        const paymentData = {
            ...state,
            paymentToken: response.token,
            paymentMethod: paymentMethod,
            tenderTypeID: parseInt(state.tenderTypeID),
            // New parameters for hosted payment page - use the exact field names from requirements
            isHostedPaymentPageResponse: true,
            hostedPaymentPageResponse: response.transactionResponse || '',
            nameOnAccount: response.holderName || '',
            // Additional reference fields for tracking
            referenceNumber: `QuickPay ${response.vendor} ${paymentMethod} - ${response.operation || 'Payment'}`,
            notes: `QuickPay ${response.vendor} Payment - Account: ${response.accountName || 'N/A'}`
        };

        // Add card details based on payment type
        if (state.tenderTypeID === '1') {
            // Extract expireMonth and expireYear from cardExpDate (format: MMYY)
            let expireMonth = '';
            let expireYear = '';

            if (response.cardExpDate && response.cardExpDate.length === 4) {
                expireMonth = response.cardExpDate.substring(0, 2); // First 2 characters (MM)
                expireYear = response.cardExpDate.substring(2, 4);  // Last 2 characters (YY)
            }

            // For credit card payments, send CardNumber, ExpireYear, ExpireMonth, and CardType
            paymentData.cardNumber = response.cardNumber || '';
            paymentData.expireYear = expireYear;
            paymentData.expireMonth = expireMonth;

            // Convert cardType from iFrame to cardTypeID for the API
            if (response.cardType) {
                paymentData.cardTypeID = getCardTypeIdFromIFrame(response.cardType);
            }

        } else if (state.tenderTypeID === '2') {
            // For eCheck payments, only send CardNumber with the account number from iFrame
            paymentData.accountNumber = response.accountNumber || '';
        }

        this.setState({ sentToBackend: true });

        // Process the payment
        this.props.quickPay(paymentData);
    }

    hasValidAmount = () => {
        const hasCustomAmount = this.state.amount !== '' && this.state.amount > 0;
        const hasAmountDue = this.state.amount === '' && this.props.quickPayAccount && this.props.quickPayAccount.totalAmountDue > 0;

        return hasCustomAmount || hasAmountDue;
    }

    getAmount = () => {
        const { amount } = this.state;
        const { totalAmountDue } = this.props.quickPayAccount;
        const customAmount = parseFloat(amount);

        if (customAmount > 0) {
            return customAmount;
        } else {
            if (totalAmountDue && totalAmountDue > 0)
                return parseFloat(totalAmountDue);
        }

        return 0.0;
    }

    getCreditCardMask = (cardNumberValueRef) => {
        var cardNumber = cardNumberValueRef.current ? cardNumberValueRef.current.value : '';
        var cardInfo = CommonStore.getCardInfo(cardNumber, false);
        return cardInfo.mask;
    }

    handleLinkClick = (e) => {
        // This prevents the page from jumping to the top
        e.preventDefault();
    };

    render() {
        const isLoading = this.props.userLoading || this.props.commonLoading || this.props.paymentLoading;
        const errorMessage = this.props.quickPayErrorMessage || this.props.paymentErrorMessage;

        return (
            <Modal className="quick-pay-modal" isOpen={this.props.quickPayModalVisible} size="lg">
                <ModalHeader toggle={this.toggle} className="bg-primary"><span className="text-white">{T.translate('quickPay.title')}</span></ModalHeader>
                <ModalBody>

                    {this.state.step === QuickPaySteps.Step1CustomerInfo && <div>
                        <div className="form-group">
                            <label htmlFor="accountNumber">{T.translate('quickPay.accountNumber')}</label>
                            <input type="text" id="accountNumber" name="accountNumber" value={this.state.accountNumber} onChange={this.onChange} className={"form-control " + (this.state.fields[0].isRequiredError ? 'is-invalid' : '')} />
                            <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="lastName">{T.translate('quickPay.lastName')}</label>
                            <input type="text" id="lastName" name="lastName" value={this.state.lastName} onChange={this.onChange} className={"form-control " + (this.state.fields[1].isRequiredError ? 'is-invalid' : '')} />
                            <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="zipCode">{T.translate('quickPay.mailingAddressZipCode')}</label>
                            <input type="text" id="zipCode" name="zipCode" value={this.state.zipCode} onChange={this.onChange} className={"form-control " + (this.state.fields[2].isRequiredError ? 'is-invalid' : '')} />
                            <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                        </div>

                        <MessageError>{errorMessage}</MessageError>

                        <LoadingButton
                            className="btn btn-primary btn-lg pull-right"
                            disabled={isLoading}
                            loading={isLoading ? 'true' : 'false'}
                            onClick={this.next}>
                            {T.translate('quickPay.nextStep')}
                        </LoadingButton>

                    </div>}

                    {this.state.step === QuickPaySteps.Step2PaymentSummary && <div>
                        <div className="row">
                            <div className="col-lg-6 mb-4">
                                <div className="card h-100">
                                    <div className="card-body d-flex">
                                        <div className="super-sever-flex-box position-relative">
                                            <img src={time} alt="time icon" />
                                            <div className="align-self-center">
                                                <p className="lead font-weight-normal font-italic mb-0">{this.props.quickPayAccount.accountBillingTypeID === 1 ? T.translate('quickPay.daysRemaining') : T.translate('quickPay.amountDue')}: </p>
                                                {this.props.showCreditBalanceOnQuickPay &&
                                                    <h6 className="card-title-lg mb-0">{this.props.quickPayAccount.accountBillingTypeID === 1 ? this.props.quickPayAccount.daysRemaining : '$' + CommonStore.formatDecimal(this.props.quickPayAccount.totalAmountDue)}</h6>
                                                }
                                                {!this.props.showCreditBalanceOnQuickPay &&
                                                    <h6 className="card-title-lg">{this.props.quickPayAccount.accountBillingTypeID === 1 ? this.props.quickPayAccount.daysRemaining : '$' + CommonStore.formatDecimal(this.props.quickPayAccount.totalAmountDue)}</h6>
                                                }
                                                {this.props.showCreditBalanceOnQuickPay && (this.props.quickPayAccount.totalAmountDue <= 0 && this.props.quickPayAccount.accountBalance > 0) &&
                                                    <p class="lead font-weight-normal font-italic mb-0 cb-label">
                                                        <b>{T.translate('quickPay.creditBalance') + ' ($' + CommonStore.formatDecimal(this.props.quickPayAccount.accountBalance) + ')'} </b>
                                                    </p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-4">
                                <div className="card h-100">
                                    <div className="card-body d-flex">
                                        <div className="super-sever-flex-box position-relative"> <img src={bag} alt="time icon" />
                                            <div className="align-self-center">
                                                <p className="lead font-weight-normal font-italic mb-0">{this.props.quickPayAccount.accountBillingTypeID === 1 ? T.translate('quickPay.availableBalance') : T.translate('quickPay.paymentDue')}: </p>
                                                <h6 className="card-title-lg">
                                                    {this.props.quickPayAccount.accountBillingTypeID === 1 ? '$' + CommonStore.formatDecimal(this.props.quickPayAccount.availableBalance) : CommonStore.formatDate(this.props.quickPayAccount.paymentDueDate)}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`row mt-3 ${this.props.useHostedPaymentPage ? 'mb-0' : 'mb-4'}`}>
                            <div className="col-lg-6 form-group">
                                <a href="#" className="btn btn-outline-dark btn-block" onClick={this.handleLinkClick} >
                                    {this.props.quickPayAccount.accountBillingTypeID === 1 ? T.translate('quickPay.paySuggestedAmount') + CommonStore.formatDecimal(this.props.quickPayAccount.suggestedPayment) : T.translate('quickPay.payTotalDue') + this.props.quickPayAccount.totalAmountDue}
                                </a>
                            </div>
                            <div className="col-lg-6 form-group">
                                <div className="pay-with-diffrent">
                                    <label htmlFor="amount">{T.translate('quickPay.payDifferentAmount')}</label>
                                    <input type="text" id="amount" name="amount" value={this.state.amount} onChange={this.onChange} className={"form-control " + (this.state.fields[3].isNumericError || this.state.fields[3].isMinimumAmountError ? 'is-invalid' : '')} />
                                    <div className="invalid-feedback">{this.state.fields[3].isMinimumAmountError ? T.translate('common.thisFieldIsLessThanMinimum') : T.translate('common.thisFieldIsNotValid')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="payment-type">{T.translate('quickPay.paymentType')}</label>
                            <select className="form-control" id="tenderTypeID" name="tenderTypeID" onChange={this.onChange} value={this.state.tenderTypeID}>
                                {this.props.systemProperties.myAcctPaymentTenderTypes.creditCard && <option value="1">{T.translate('quickPay.creditCard')}</option>}
                                {this.props.systemProperties.myAcctPaymentTenderTypes.eCheck && <option value="2">{T.translate('quickPay.eCheck')}</option>}
                            </select>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <PaymentSummary amount={this.getAmount()} />
                            </div>
                        </div>

                        <MessageError>{errorMessage}</MessageError>

                        <button type="button" className="btn" disabled={isLoading} onClick={this.back}>{T.translate('common.back')}</button>

                        <LoadingButton
                            className="btn btn-primary btn-lg pull-right"
                            disabled={isLoading}
                            loading={isLoading ? 'true' : 'false'}
                            onClick={this.next}>
                            {T.translate('quickPay.nextStep')}
                        </LoadingButton>
                    </div>}

                    {this.state.step === QuickPaySteps.Step3PaymentSending && <div>

                        {/* Loading overlay for all payment processing including iframe */}
                        <LoadingOverlay loading={isLoading} />

                        <div className="row">
                            <div className="col-lg-12">
                                <PaymentSummary amount={this.getAmount()} />
                            </div>
                        </div>

                        <form>
                            {/* Show iFrame component if useHostedPaymentPage is true */}
                            {this.props.useHostedPaymentPage && (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <IFrameManager
                                            sourceName="QuickPayModal"
                                            paymentMethod={this.state.tenderTypeID === '1' ? "CreditCard" : "eCheck"}
                                            paymentProviderID={this.props.paymentProviderID}
                                            paymentVendorProcessTypeID={PaymentVendorProcessType.RegularPayment}
                                            amount={this.state.amount || (this.props.quickPayAccount && this.props.quickPayAccount.totalAmountDue)}
                                            sourceAccount={this.props.quickPayAccount}
                                            paymentAttemptID={this.props.paymentAttemptID}
                                            onLoaded={this.onIFrameLoaded}
                                            content={this.props.hostedPaymentPageContent}
                                            onIFrameResponse={this.onIFrameResponse}
                                            onPaymentSuccess={this.onIFramePaymentSuccess}
                                            setPaymentError={this.props.setQuickPayError}
                                            setIFrameToken={this.props.setIFrameToken}
                                            hideBorder={true}
                                            disabled={!this.hasValidAmount()}
                                            height="560px"
                                        />
                                    </div>
                                </div>
                            )}

                            {this.state.tenderTypeID === '1' && <div>
                                {/* Hide traditional Credit Card form when using hosted payment page */}
                                {!this.props.useHostedPaymentPage && (
                                    <div>
                                        {!this.props.getPaymentStripePK() && <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group credit-card-input">
                                                    <label htmlFor="cardNumberValue">{T.translate('quickPay.cardNumber')}</label>
                                                    <InputMask ref={this.cardNumberValueRef} mask={this.getCreditCardMask(this.cardNumberValueRef)} placeholder="#### #### #### ####" id="cardNumberValue" name="cardNumberValue" onChange={this.onChange} className={"form-control " + (this.state.fields[4].isRequiredError ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="expiration">{T.translate('quickPay.expiration')}</label>
                                                    <InputMask ref={this.expirationRef} mask="99/99" placeholder="MM/YY" id="expiration" name="expiration" onChange={this.onChange} className={"form-control " + (this.state.fields[5].isRequiredError ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="ccv">{T.translate('quickPay.securityCode')}</label>
                                                    <input type="text" ref={this.ccvRef} id="ccv" name="ccv" maxLength={4} onChange={this.onChange} className={"form-control " + (this.state.fields[6].isRequiredError ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                </div>
                                            </div>
                                        </div>}

                                        {this.props.getPaymentStripePK() &&
                                            <div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group credit-card-input">
                                                            <label htmlFor="cardNumberValue">{T.translate('accountPay.cardNumber')}</label>
                                                            <div id="txtCreditCardStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 60px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="expiration">{T.translate('accountPay.expiration')}</label>
                                                            <div id="txtExpireStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 17px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="ccv">{T.translate('accountPay.securityCode')}</label>
                                                            <div id="txtCcvStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 17px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="nameOnAccount">{T.translate('quickPay.nameOnCard')}</label>
                                                    <input type="text" id="nameOnAccount" name="nameOnAccount" value={this.state.nameOnAccount} onChange={this.onChange} className={"form-control " + (this.state.fields[7].isRequiredError ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="cardZipCode">{T.translate('quickPay.billingZip')}</label>
                                                    <input type="text" name="cardZipCode" id="cardZipCode" value={this.state.cardZipCode} onChange={this.onChange} className={"form-control " + (this.state.fields[8].isRequiredError ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <React.Fragment>
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <p>
                                                        <FontAwesomeIcon className="card-flex-icon mr-2" icon={faInfoCircle} onClick={this.openCreditCardFeeModal} />
                                                        {T.translate(
                                                            this.showCreditCardFeeWarning() ?
                                                                'quickPay.paymentusCreditCardFeeWarning' :
                                                                'quickPay.paymentusCreditCardNoFeeWarning',
                                                            { paymentusCreditCardFee: this.props.systemProperties.creditCardCharge })}
                                                    </p>
                                                </div>
                                            </div>

                                            <ConfirmModal
                                                title={T.translate(
                                                    this.showCreditCardFeeWarning() ?
                                                        'suggestedPayment.paymentsIncursTitle' :
                                                        'suggestedPayment.paymentDoesNotIncurFeesTitle',
                                                    { paymentMethod: T.translate('quickPay.paymentusCreditCard') }
                                                )}
                                                open={this.state.infoCreditCardFeeModalVisible}
                                                onToggle={this.closeCreditCardFeeModal}>
                                                <div>
                                                    {this.props.systemProperties.myacctPaymentConvenienceFeeMessage
                                                        ? <p>{this.props.systemProperties.myacctPaymentConvenienceFeeMessage}</p>
                                                        : <p>{T.translate(
                                                            this.showCreditCardFeeWarning() ?
                                                                'suggestedPayment.paymentsIncursBodyOne' :
                                                                'suggestedPayment.paymentDoesNotIncurFeesBody'
                                                        )}</p>}

                                                </div>
                                            </ConfirmModal>
                                        </React.Fragment>
                                    </div>
                                )}
                            </div>}

                            {this.state.tenderTypeID === '2' && <div>
                                {/* Hide traditional eCheck form when using hosted payment page */}
                                {!this.props.useHostedPaymentPage && (
                                    <div>
                                        {!this.props.paymentStripe && <div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="accountNumber">{T.translate('accountPay.bankAccountNumber')}</label>
                                                        <input type="text" id="bankAccountNumber" name="bankAccountNumber" maxLength={17} value={this.state.bankAccountNumber} onChange={this.onChange} className={"form-control " + (this.state.fields[9].isRequiredError ? 'is-invalid' : '')} />
                                                        <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="bankAccountType">{T.translate('autopay.bankAccountType')}</label>
                                                        <select className="form-control" id="bankAccountType" name="bankAccountType" value={this.state.bankAccountType} onChange={this.onChange}>
                                                            {
                                                                this.props.systemProperties.bankAccountTypes.map(function (type) {
                                                                    return <option key={type.value} value={type.value}>{type.name}</option>;
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="routingNumber">{T.translate('accountPay.routingNumber')}</label>
                                                        <input id="routingNumber" name="routingNumber" maxLength={9} value={this.state.routingNumber} onChange={this.onChange} className={"form-control " + (this.state.fields[10].isRequiredError ? 'is-invalid' : '')} />
                                                        <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <p>
                                                            <FontAwesomeIcon className="card-flex-icon mr-2" icon={faInfoCircle} onClick={this.openCreditCardFeeModal} />
                                                            {T.translate(
                                                                this.showeCheckFeeWarning() ?
                                                                    'quickPay.paymentuseCheckFeeWarning' :
                                                                    'quickPay.paymentuseCheckNoFeeWarning')}
                                                        </p>
                                                    </div>
                                                </div>

                                                <ConfirmModal
                                                    title={T.translate(
                                                        this.showeCheckFeeWarning() ?
                                                            'suggestedPayment.paymentsIncursTitle' :
                                                            'suggestedPayment.paymentDoesNotIncurFeesTitle',
                                                        { paymentMethod: T.translate('quickPay.eCheck') }
                                                    )}
                                                    open={this.state.infoCreditCardFeeModalVisible}
                                                    onToggle={this.closeCreditCardFeeModal}>
                                                    <div>
                                                        {this.props.systemProperties.myacctPaymentConvenienceFeeMessage
                                                            ? <p>{this.props.systemProperties.myacctPaymentConvenienceFeeMessage}</p>
                                                            : <p>{T.translate(
                                                                this.showeCheckFeeWarning() ?
                                                                    'suggestedPayment.paymentsIncursBodyOne' :
                                                                    'suggestedPayment.paymentDoesNotIncurFeesBody'
                                                            )}</p>}

                                                    </div>
                                                </ConfirmModal>
                                            </React.Fragment>
                                        </div>}

                                        {this.props.paymentStripe && <div>

                                            <div className="row form-group">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <button type="button" className="btn" onClick={() => this.setState({ reactPlaidOpen: true })}>{T.translate('accountPay.clickSelectBankAccount')}</button>
                                                        {this.state.fields[11].isRequiredError && <div className="invalid-feedback" style={{ display: 'block' }}>{T.translate('common.thisFieldIsRequired')}</div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <ReactPlaid
                                                clientName={this.props.paymentStripe.clientName}
                                                product={this.props.paymentStripe.product}
                                                apiKey={this.props.paymentStripe.apiKey}
                                                env={this.props.paymentStripe.env}
                                                selectAccount={this.props.paymentStripe.selectAccount}
                                                open={this.state.reactPlaidOpen}
                                                onSuccess={(token, metaData) => this.reactPlaidSuccess(token, metaData)}
                                                onExit={() => this.setState({ reactPlaidOpen: false })}
                                            />
                                        </div>}
                                    </div>
                                )}
                            </div>}

                            <MessageError>{errorMessage}</MessageError>

                            <div className={`diverter ${this.props.useHostedPaymentPage ? 'mt-4' : 'mt-0'} mb-4`} />

                            {/* Hide tokenization checkbox when using hosted payment page */}
                            {!this.props.useHostedPaymentPage && (
                                <div>
                                    <div>
                                        <p>{T.translate("accountPay.tokenizeCreditDetails")}</p>
                                    </div>

                                    <div className="checkbox">
                                        <label>
                                            <input className="coupon_question sign-up-checkbox mr-1" name="tokenizeCreditDetails" id="tokenizeCreditDetails" value="1" type="checkbox" checked={this.state.tokenizeCreditDetails} onChange={this.onTokenizeCreditDetailsClick} />
                                            {T.translate("accountPay.agreeOnTokenizeCreditDetails")}
                                        </label>
                                    </div>
                                </div>
                            )}

                            <button type="button" className="btn" disabled={isLoading} onClick={this.back}>{T.translate('common.back')}</button>

                            {/* Hide Pay Now button when using hosted payment page - iframe handles payment submission */}
                            {!this.props.useHostedPaymentPage && (
                                <LoadingButton
                                    type="button"
                                    className="btn btn-primary pull-right"
                                    disabled={this.state.sentToBackend || isLoading || !this.state.tokenizeCreditDetails}
                                    loading={isLoading ? 'true' : 'false'}
                                    onClick={this.pay}>
                                    {T.translate('quickPay.payNow')}
                                </LoadingButton>
                            )}

                        </form>
                    </div>}

                    {this.state.step === QuickPaySteps.Step4PaymentConfirmation && <div>
                        <div className="alert alert-success mb-5 mt-4 p-4 fade in alert-dismissible show d-flex">
                            <div className="d-flex">
                                <FontAwesomeIcon className="mr-3" size="2x" icon={faCheckCircle} />
                                <div>
                                    <p>{T.translate('quickPay.yourPaymentHasBeenAccepted')}</p>
                                    <p className="font-weight-bold">{T.translate('quickPay.yourPaymentConfirmationNumberIs')}</p>
                                    <p>{this.props.quickPayConfirmationNumber}</p>
                                </div>
                            </div>
                        </div>
                        <button type="button" className="btn pull-right" onClick={this.toggle}>{T.translate('common.close')}</button>
                    </div>}

                </ModalBody>
            </Modal>
        );
    }
}

export default connect(
    state => ({ ...state.user, ...state.common, ...state.payment }),
    dispatch => bindActionCreators({ ...UserStore.actionCreators, ...CommonStore.actionCreators, ...PaymentStore.actionCreators }, dispatch)
)(QuickPayModal);
